import { faXmark } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React from "react";
import { Button, Toast, ToastContainer } from "react-bootstrap";

import { useAppDispatch, useAppSelector } from "../../redux/Store";
import { hideToastMsg, selectorToast } from "../../redux/slice/ToastMsgSlice";
import FASvgIcon from "../FASvgIcon";

type Props = {};

const ShowToastMsg: React.FC<Props> = (props: Props) => {
  const dispatch = useAppDispatch();
  const { isVisible, title, message, variant } = useAppSelector(selectorToast);

  return (
    <ToastContainer containerPosition="fixed" position="top-end">
      <Toast
        bg="white"
        show={isVisible}
        delay={5000}
        autohide={true}
        onClose={() => dispatch(hideToastMsg())}
        className={classNames("eds-toast", `border-${variant}-subtle`)}
      >
        <Toast.Header closeButton={false}>
          <div className="toast-header-content">
            {title && <h4 className={classNames("toast-title", `text-${variant}`)}>{title}</h4>}
            <p className={classNames("toast-message")}>{message}</p>
          </div>
          <Button
            variant="primary"
            className="icon-only hide-toast"
            onClick={() => dispatch(hideToastMsg())}
          >
            <FASvgIcon icon={faXmark} />
          </Button>
        </Toast.Header>
      </Toast>
    </ToastContainer>
  );
};

export default ShowToastMsg;
